/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Address model module.
 * @module model/Address
 * @version 1.1.0
 */
class Address {
    /**
     * Constructs a new <code>Address</code>.
     * @alias module:model/Address
     */
    constructor() { 
        
        Address.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Address</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Address} obj Optional instance to populate.
     * @return {module:model/Address} The populated <code>Address</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Address();

            if (data.hasOwnProperty('streetAddr')) {
                obj['streetAddr'] = ApiClient.convertToType(data['streetAddr'], 'String');
            }
            if (data.hasOwnProperty('street2Addr')) {
                obj['street2Addr'] = ApiClient.convertToType(data['street2Addr'], 'String');
            }
            if (data.hasOwnProperty('cityAddr')) {
                obj['cityAddr'] = ApiClient.convertToType(data['cityAddr'], 'String');
            }
            if (data.hasOwnProperty('stateProvinceAddr')) {
                obj['stateProvinceAddr'] = ApiClient.convertToType(data['stateProvinceAddr'], 'String');
            }
            if (data.hasOwnProperty('postalCodeAddr')) {
                obj['postalCodeAddr'] = ApiClient.convertToType(data['postalCodeAddr'], 'String');
            }
            if (data.hasOwnProperty('countryAddr')) {
                obj['countryAddr'] = ApiClient.convertToType(data['countryAddr'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Address</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Address</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['streetAddr'] && !(typeof data['streetAddr'] === 'string' || data['streetAddr'] instanceof String)) {
            throw new Error("Expected the field `streetAddr` to be a primitive type in the JSON string but got " + data['streetAddr']);
        }
        // ensure the json data is a string
        if (data['street2Addr'] && !(typeof data['street2Addr'] === 'string' || data['street2Addr'] instanceof String)) {
            throw new Error("Expected the field `street2Addr` to be a primitive type in the JSON string but got " + data['street2Addr']);
        }
        // ensure the json data is a string
        if (data['cityAddr'] && !(typeof data['cityAddr'] === 'string' || data['cityAddr'] instanceof String)) {
            throw new Error("Expected the field `cityAddr` to be a primitive type in the JSON string but got " + data['cityAddr']);
        }
        // ensure the json data is a string
        if (data['stateProvinceAddr'] && !(typeof data['stateProvinceAddr'] === 'string' || data['stateProvinceAddr'] instanceof String)) {
            throw new Error("Expected the field `stateProvinceAddr` to be a primitive type in the JSON string but got " + data['stateProvinceAddr']);
        }
        // ensure the json data is a string
        if (data['postalCodeAddr'] && !(typeof data['postalCodeAddr'] === 'string' || data['postalCodeAddr'] instanceof String)) {
            throw new Error("Expected the field `postalCodeAddr` to be a primitive type in the JSON string but got " + data['postalCodeAddr']);
        }
        // ensure the json data is a string
        if (data['countryAddr'] && !(typeof data['countryAddr'] === 'string' || data['countryAddr'] instanceof String)) {
            throw new Error("Expected the field `countryAddr` to be a primitive type in the JSON string but got " + data['countryAddr']);
        }

        return true;
    }


}



/**
 * @member {String} streetAddr
 */
Address.prototype['streetAddr'] = undefined;

/**
 * @member {String} street2Addr
 */
Address.prototype['street2Addr'] = undefined;

/**
 * @member {String} cityAddr
 */
Address.prototype['cityAddr'] = undefined;

/**
 * @member {String} stateProvinceAddr
 */
Address.prototype['stateProvinceAddr'] = undefined;

/**
 * @member {String} postalCodeAddr
 */
Address.prototype['postalCodeAddr'] = undefined;

/**
 * @member {String} countryAddr
 */
Address.prototype['countryAddr'] = undefined;






export default Address;

